import { calcCartTotalHandler } from "@/helpers/cart";
import { validateImgSrc } from "../global";

function getDiscount(original_price, price) {
  return original_price !== price && price !== 0 ? original_price - price : 0;
}

function priceBeforeTax(priceWithTax) {
  const taxRate = 0.15;
  const priceBeforeTax = priceWithTax / (1 + taxRate);
  return Number(priceBeforeTax || 0)?.toFixed(2);
}

function getTotalPrices(products) {
  return products?.reduce(
    (price, cur) =>
      (cur?.qty || 1) * (cur?.prices_with_tax?.price || cur?.price) + price,
    0
  );
}

function getTotalDiscount(products) {
  return products?.reduce((curr, item) => {
    return (
      curr +
      ((item?.prices_with_tax?.original_price ||
        item?.extension_attributes?.original_price ||
        item?.prices?.original_price ||
        item?.original_price) -
        (item?.prices_with_tax?.price ||
          item?.extension_attributes?.special_price ||
          item?.prices?.price ||
          item?.price))
    );
  }, 0);
}

// Update Cart Event
export const update_cart_event = (data, from_mini_cart, from_add_event) => {
  const cart_items =
    Object.keys(data?.cart || {}).length === 0 || from_mini_cart
      ? data?.cartItems
      : data?.cart?.items;
  pushToDataLayer("update_cart_event", {
    category_name: cart_items
      ?.map(
        (info) =>
          info?._category_?.main_category?.name ||
          info?.extension_attributes?.category_names?.at(0)
      )
      .join(","),
    sku_ids: cart_items
      ?.map((info) =>
        info?.extension_attributes?.product_sku
          ? Array.isArray(info?.extension_attributes?.product_sku)
            ? info?.extension_attributes?.product_sku?.[0]
            : info?.extension_attributes?.product_sku
          : Array.isArray(info?.sku)
          ? info?.sku?.[0]
          : info?.sku
      )
      .join(","),
    sku_names: cart_items
      ?.map((info) =>
        Array.isArray(info?.name) ? info?.name?.[0] : info?.name
      )
      .join(","),
    count_of_products: cart_items?.length,
    line_items: cart_items?.map((info) => ({
      image:
        info?._media_?.image?.[0]?.image ||
        validateImgSrc(
          `${process.env.NEXT_PUBLIC_IMG_BASEURL}/catalog/product${info?.extension_attributes?.product_image}`
        ),
      quantity: info?.qty || 1,
      price:
        info?.prices_with_tax?.price ||
        info?.extension_attributes?.special_price ||
        info?.extension_attributes?.original_price,
      skuId:
        info?.extension_attributes?.product_sku ||
        (Array.isArray(info?.sku) ? info?.sku?.[0] : info?.sku),
      skuname: Array.isArray(info?.name) ? info?.name?.[0] : info?.name,
    })),
    total: from_add_event
      ? calcCartTotalHandler(data?.cartItems || [])
      : Object.keys(data?.cart || {}).length === 0 || from_mini_cart
      ? getTotalPrices(cart_items)
      : data?.cart?.grand_total,
    sub_total: from_add_event
      ? priceBeforeTax(calcCartTotalHandler(data?.cartItems || []))
      : Object.keys(data?.cart || {}).length === 0 || from_mini_cart
      ? priceBeforeTax(getTotalPrices(cart_items))
      : data?.cart?.subtotal,
    sub_category_name: cart_items
      ?.map(
        (info) =>
          info?._category_?.sub_categories?.[1]?.name ||
          info?.extension_attributes?.category_names?.at(1)
      )
      .join(","),
    total_discount: Number(getTotalDiscount(cart_items))?.toFixed(2),
  });
};

export const pushToDataLayer = (event, data, session) => {
  if (typeof window != undefined) {
    const user_mobile = session?.user?.custom_attributes?.find(
      (attr) => attr?.attribute_code === "mobile_number"
    )?.value;
    window.dataLayer = window.dataLayer || [];
    window?.dataLayer?.push({ ecommerce: null });
    window?.dataLayer?.push({
      event,
      ecommerce: data,
      ...(session && {
        user: {
          ...(session?.user?.id && { id: session?.user?.id }),
          name: `${session?.user?.firstname} ${session?.user?.lastname}`,
          email: session?.user?.email,
          mobile_number: user_mobile?.startsWith("00966")
            ? `+${user_mobile?.slice(2)}`
            : user_mobile?.startsWith("966")
            ? `+${user_mobile}`
            : `+966${user_mobile?.value}`,
        },
      }),
    });
  }
};

// Success Page

export const event_purchase = (
  order,
  session,
  email,
  firstname,
  lastname,
  telephone,
  total_granted,
  total_completed_orders
) => {
  return pushToDataLayer(
    "purchase",
    {
      transaction_id: order?.increment_id,
      order_id: order?.entity_id,
      value: order?.grand_total,
      total: priceBeforeTax(order?.grand_total),
      tax: order?.tax_amount,
      sub_total: order?.subtotal,
      shipping: order?.shipping_amount,
      currency: "SAR",
      payment_mode: order?.payment?.method,
      discount: getTotalDiscount(order?.items || []),
      source: "online",
      line_items: order?.items?.map((item, i) => {
        return {
          item_id: item?.sku,
          item_name: item?.name,
          // coupon: "SUMMER_FUN",
          discount: getDiscount(
            item?.extension_attributes?.original_price,
            item?.extension_attributes?.special_price
          ),
          index: i + 1,
          ...(item?.extension_attributes?.brand_name && {
            item_brand: item?.extension_attributes?.brand_name,
          }),
          ...(item?.extension_attributes?.category_names?.at(0) && {
            category_name: item?.extension_attributes?.category_names?.at(0),
            // item?.extension_attributes?.category_names?.at(0)?.name,
            // category_id: item?.extension_attributes?.category_names?.at(0)?.id,
          }),
          ...(item?.extension_attributes?.category_names?.at(1) && {
            item_category1: item?.extension_attributes?.category_names?.at(1),
            // item?.extension_attributes?.category_names?.at(1)?.name,
            // item_category1_id:
            //   item?.extension_attributes?.category_names?.at(1)?.id,
          }),
          ...(item?.extension_attributes?.category_names?.at(2) && {
            item_category2:
              // item?.extension_attributes?.category_names?.at(2)?.name,
              item?.extension_attributes?.category_names?.at(2),
            // item_category2_id:
            //   item?.extension_attributes?.category_names?.at(2)?.id,
          }),
          ...(item?.extension_attributes?.category_names?.at(3) && {
            item_category3:
              // item?.extension_attributes?.category_names?.at(3)?.name,
              item?.extension_attributes?.category_names?.at(3),
            // item_category3_id:
            //   item?.extension_attributes?.category_names?.at(3)?.id,
          }),
          ...(item?.extension_attributes?.category_names?.at(4) && {
            item_category4: item?.extension_attributes?.category_names?.at(4),
            // item?.extension_attributes?.category_names?.at(4)?.name,
            // item_category4_id:
            //   item?.extension_attributes?.category_names?.at(4)?.id,
          }),
          ...(item?.extension_attributes?.category_names?.at(5) && {
            item_category5: item?.extension_attributes?.category_names?.at(5),
            //   item?.extension_attributes?.category_names?.at(5),
            // item_category5_id:
            //   item?.extension_attributes?.category_names?.at(5)?.id,
          }),
          price:
            item?.extension_attributes?.special_price ||
            item?.extension_attributes?.original_price,
          quantity: item?.qty_ordered,
        };
      }),
      sku_ids: order?.items?.map((item) => item?.sku).join(","),
      sku_names: order?.items?.map((item) => item?.name).join(","),
      number_of_products: order?.items?.length,
      ...(total_granted && { total_ltv_user_attribute: total_granted }),
      ...(total_completed_orders && {
        total_order_count_user_attribute: total_completed_orders,
      }),
    },
    session?.user
      ? session
      : {
          user: {
            firstname,
            lastname,
            email,
            custom_attributes: [
              { attribute_code: "mobile_number", value: telephone },
            ],
          },
        }
  );
};

/* Check out Page  */
export const event_checkout_started = (cartData) => {
  return pushToDataLayer("begin_checkout", {
    currency: "SAR",
    value: cartData?.grand_total,
    total: priceBeforeTax(cartData?.grand_total),
    discount: getTotalDiscount(cartData?.items),
    items: cartData?.items?.map((item, i) => {
      return {
        item_id: item?.extension_attributes?.product_sku,
        item_name: item?.name,
        discount: getDiscount(
          item?.extension_attributes?.original_price,
          item?.extension_attributes?.special_price
        ),
        product_image: `${process.env.NEXT_PUBLIC_IMG_BASEURL}/catalog/product/${item?.extension_attributes?.product_image}`,
        index: i + 1,
        ...(item?.extension_attributes?.brand_name && {
          item_brand: item?.extension_attributes?.brand_name,
        }),
        ...(item?.extension_attributes?.category_names?.at(0) && {
          category_name: item?.extension_attributes?.category_names?.at(0),
          // item?.extension_attributes?.category_names?.at(0)?.name,
          // category_id: item?.extension_attributes?.category_names?.at(0)?.id,
        }),
        ...(item?.extension_attributes?.category_names?.at(1) && {
          item_category1: item?.extension_attributes?.category_names?.at(1),
          // item?.extension_attributes?.category_names?.at(1)?.name,
          // item_category1_id:
          //   item?.extension_attributes?.category_names?.at(1)?.id,
        }),
        ...(item?.extension_attributes?.category_names?.at(2) && {
          item_category2:
            // item?.extension_attributes?.category_names?.at(2)?.name,
            item?.extension_attributes?.category_names?.at(2),
          // item_category2_id:
          //   item?.extension_attributes?.category_names?.at(2)?.id,
        }),
        ...(item?.extension_attributes?.category_names?.at(3) && {
          item_category3:
            // item?.extension_attributes?.category_names?.at(3)?.name,
            item?.extension_attributes?.category_names?.at(3),
          // item_category3_id:
          //   item?.extension_attributes?.category_names?.at(3)?.id,
        }),
        ...(item?.extension_attributes?.category_names?.at(4) && {
          item_category4: item?.extension_attributes?.category_names?.at(4),
          // item?.extension_attributes?.category_names?.at(4)?.name,
          // item_category4_id:
          //   item?.extension_attributes?.category_names?.at(4)?.id,
        }),
        ...(item?.extension_attributes?.category_names?.at(5) && {
          item_category5: item?.extension_attributes?.category_names?.at(5),
          //   item?.extension_attributes?.category_names?.at(5),
          // item_category5_id:
          //   item?.extension_attributes?.category_names?.at(5)?.id,
        }),
        price:
          item?.extension_attributes?.special_price ||
          item?.extension_attributes?.original_price,
        quantity: item?.qty,
      };
    }),
    number_of_products: cartData?.items?.length,
    sku_ids: cartData?.items
      ?.map((item) => item?.extension_attributes?.product_sku)
      ?.join(","),
    names: cartData?.items?.map((item) => item?.name)?.join(","),
    category_names: cartData?.items
      ?.map((item) => item?.extension_attributes?.category_names?.at(0)?.name)
      ?.join(","),
    sub_category_names: cartData?.items
      ?.map((item) => item?.extension_attributes?.category_names?.at(1)?.name)
      ?.join(","),
    ...(cartData?.tax_amount && { tax_amount: cartData?.tax_amount }),
  });
};

export const event_shipping_info = (cartData, info, session) => {
  event_user_login({
    firstname: session?.user?.firstname || info?.firstname,
    lastname: session?.user?.lastname || info?.lastname,
    email: session?.user?.email || info?.email,
    custom_attributes: [
      { attribute_code: "mobile_number", value: info?.telephone },
    ],
  });
  return pushToDataLayer("add_contact_info", {
    currency: "SAR",
    value: cartData?.grand_total,
    total: priceBeforeTax(cartData?.grand_total),
    ...((info?.city || info?.region) && {
      city: info?.city || info?.region,
      district: info?.city || info?.region,
    }),
    street: info?.street,
    ...(!session?.user
      ? {
          name: info?.firstname + " " + info?.lastname,
          email: info?.email,
          phone: info?.telephone,
        }
      : {
          first_name: session?.user?.firstname,
          last_name: session?.user?.lastname,
          mobile_number: info?.telephone,
        }),
    items: cartData?.items?.map((item, i) => {
      return {
        item_id: item?.extension_attributes?.product_sku,
        item_name: item?.name,
        discount: getDiscount(
          item?.extension_attributes?.original_price,
          item?.extension_attributes?.special_price
        ),
        index: i + 1,
        ...(item?.extension_attributes?.brand_name && {
          item_brand: item?.extension_attributes?.brand_name,
        }),
        ...(item?.extension_attributes?.category_names?.at(0) && {
          category_name: item?.extension_attributes?.category_names?.at(0),
          // item?.extension_attributes?.category_names?.at(0)?.name,
          // category_id: item?.extension_attributes?.category_names?.at(0)?.id,
        }),
        ...(item?.extension_attributes?.category_names?.at(1) && {
          item_category1: item?.extension_attributes?.category_names?.at(1),
          // item?.extension_attributes?.category_names?.at(1)?.name,
          // item_category1_id:
          //   item?.extension_attributes?.category_names?.at(1)?.id,
        }),
        ...(item?.extension_attributes?.category_names?.at(2) && {
          item_category2:
            // item?.extension_attributes?.category_names?.at(2)?.name,
            item?.extension_attributes?.category_names?.at(2),
          // item_category2_id:
          //   item?.extension_attributes?.category_names?.at(2)?.id,
        }),
        ...(item?.extension_attributes?.category_names?.at(3) && {
          item_category3:
            // item?.extension_attributes?.category_names?.at(3)?.name,
            item?.extension_attributes?.category_names?.at(3),
          // item_category3_id:
          //   item?.extension_attributes?.category_names?.at(3)?.id,
        }),
        ...(item?.extension_attributes?.category_names?.at(4) && {
          item_category4: item?.extension_attributes?.category_names?.at(4),
          // item?.extension_attributes?.category_names?.at(4)?.name,
          // item_category4_id:
          //   item?.extension_attributes?.category_names?.at(4)?.id,
        }),
        ...(item?.extension_attributes?.category_names?.at(5) && {
          item_category5: item?.extension_attributes?.category_names?.at(5),
          //   item?.extension_attributes?.category_names?.at(5),
          // item_category5_id:
          //   item?.extension_attributes?.category_names?.at(5)?.id,
        }),
        product_image: `${process.env.NEXT_PUBLIC_IMG_BASEURL}/catalog/product/${item?.extension_attributes?.product_image}`,
        price:
          item?.extension_attributes?.special_price ||
          item?.extension_attributes?.original_price,
        quantity: item?.qty,
      };
    }),
    sku_ids: cartData?.items
      ?.map((item) => item?.extension_attributes?.product_sku)
      ?.join(","),
    names: cartData?.items?.map((item) => item?.name)?.join(","),
    number_of_products: cartData?.items?.length || 0,
    // subtotal: cartData?.subtotal,
    ...(cartData?.tax_amount && { tax_amount: cartData?.tax_amount }),
    discount: getTotalDiscount(cartData?.items),
  });
};

export const event_payment_info = (cartData, payment_type) =>
  pushToDataLayer("add_payment_info", {
    currency: "SAR",
    value: cartData?.grand_total,
    // coupon: "SUMMER_FUN",
    payment_type,
    items: cartData?.items?.map((item, i) => {
      return {
        item_id: item?.extension_attributes?.product_sku,
        item_name: item?.name,
        // coupon: "SUMMER_FUN",
        discount: getDiscount(
          item?.extension_attributes?.original_price,
          item?.extension_attributes?.special_price
        ),
        index: i + 1,
        ...(item?.extension_attributes?.brand_name && {
          item_brand: item?.extension_attributes?.brand_name,
        }),
        ...(item?.extension_attributes?.category_names?.at(0) && {
          category_name: item?.extension_attributes?.category_names?.at(0),
          // item?.extension_attributes?.category_names?.at(0)?.name,
          // category_id: item?.extension_attributes?.category_names?.at(0)?.id,
        }),
        ...(item?.extension_attributes?.category_names?.at(1) && {
          item_category1: item?.extension_attributes?.category_names?.at(1),
          // item?.extension_attributes?.category_names?.at(1)?.name,
          // item_category1_id:
          //   item?.extension_attributes?.category_names?.at(1)?.id,
        }),
        ...(item?.extension_attributes?.category_names?.at(2) && {
          item_category2:
            // item?.extension_attributes?.category_names?.at(2)?.name,
            item?.extension_attributes?.category_names?.at(2),
          // item_category2_id:
          //   item?.extension_attributes?.category_names?.at(2)?.id,
        }),
        ...(item?.extension_attributes?.category_names?.at(3) && {
          item_category3:
            // item?.extension_attributes?.category_names?.at(3)?.name,
            item?.extension_attributes?.category_names?.at(3),
          // item_category3_id:
          //   item?.extension_attributes?.category_names?.at(3)?.id,
        }),
        ...(item?.extension_attributes?.category_names?.at(4) && {
          item_category4: item?.extension_attributes?.category_names?.at(4),
          // item?.extension_attributes?.category_names?.at(4)?.name,
          // item_category4_id:
          //   item?.extension_attributes?.category_names?.at(4)?.id,
        }),
        ...(item?.extension_attributes?.category_names?.at(5) && {
          item_category5: item?.extension_attributes?.category_names?.at(5),
          //   item?.extension_attributes?.category_names?.at(5),
          // item_category5_id:
          //   item?.extension_attributes?.category_names?.at(5)?.id,
        }),
        price:
          item?.extension_attributes?.special_price ||
          item?.extension_attributes?.original_price,
        quantity: item?.qty,
      };
    }),
  });

// Cart Section
export const event_view_cart = (cartData) => {
  return pushToDataLayer("view_cart", {
    currency: "SAR",
    value: cartData?.grand_total,
    total: priceBeforeTax(cartData?.grand_total),
    discount: getTotalDiscount(cartData?.items),
    items: cartData?.items?.map((item, i) => {
      return {
        item_id: item?.extension_attributes?.product_sku,
        item_name: item?.name,
        image: `${process.env.NEXT_PUBLIC_IMG_BASEURL}/catalog/product/${item?.extension_attributes?.product_image}`,
        discount: getDiscount(
          item?.extension_attributes?.original_price,
          item?.extension_attributes?.special_price
        ),
        index: i + 1,
        ...(item?.extension_attributes?.brand_name && {
          item_brand: item?.extension_attributes?.brand_name,
        }),
        ...(item?.extension_attributes?.category_names?.at(0) && {
          category_name: item?.extension_attributes?.category_names?.at(0),
          // item?.extension_attributes?.category_names?.at(0)?.name,
          // category_id: item?.extension_attributes?.category_names?.at(0)?.id,
        }),
        ...(item?.extension_attributes?.category_names?.at(1) && {
          item_category1: item?.extension_attributes?.category_names?.at(1),
          // item?.extension_attributes?.category_names?.at(1)?.name,
          // item_category1_id:
          //   item?.extension_attributes?.category_names?.at(1)?.id,
        }),
        ...(item?.extension_attributes?.category_names?.at(2) && {
          item_category2:
            // item?.extension_attributes?.category_names?.at(2)?.name,
            item?.extension_attributes?.category_names?.at(2),
          // item_category2_id:
          //   item?.extension_attributes?.category_names?.at(2)?.id,
        }),
        ...(item?.extension_attributes?.category_names?.at(3) && {
          item_category3:
            // item?.extension_attributes?.category_names?.at(3)?.name,
            item?.extension_attributes?.category_names?.at(3),
          // item_category3_id:
          //   item?.extension_attributes?.category_names?.at(3)?.id,
        }),
        ...(item?.extension_attributes?.category_names?.at(4) && {
          item_category4: item?.extension_attributes?.category_names?.at(4),
          // item?.extension_attributes?.category_names?.at(4)?.name,
          // item_category4_id:
          //   item?.extension_attributes?.category_names?.at(4)?.id,
        }),
        ...(item?.extension_attributes?.category_names?.at(5) && {
          item_category5: item?.extension_attributes?.category_names?.at(5),
          //   item?.extension_attributes?.category_names?.at(5),
          // item_category5_id:
          //   item?.extension_attributes?.category_names?.at(5)?.id,
        }),
        price:
          item?.extension_attributes?.special_price ||
          item?.extension_attributes?.original_price,
        quantity: item?.qty,
      };
    }),
    item_ids: cartData?.items
      ?.map((item) => item?.extension_attributes?.product_sku)
      .join(","),
    item_names: cartData?.items?.map((item) => item?.name).join(","),
    number_of_products: cartData?.items.length || 0,
    ...(cartData?.tax_amount && { tax_amount: cartData?.tax_amount }),
  });
};

export const event_remove_from_cart = (product) => {
  return pushToDataLayer("remove_from_cart", {
    currency: "SAR",
    value:
      product?.qty *
      (product?.extension_attributes?.special_price ||
        product?.extension_attributes?.price ||
        product?.prices_with_tax?.original_price),
    items: [
      {
        item_id: product?.extension_attributes?.product_sku || product?.sku,
        item_name: Array.isArray(product?.name)
          ? product?.name?.[0]
          : product?.name,
        // coupon: "SUMMER_FUN",
        discount: getDiscount(
          product?.extension_attributes?.original_price ||
            product?.prices_with_tax?.original_price,
          product?.extension_attributes?.special_price ||
            product?.prices_with_tax?.price
        ),
        index: 1,
        ...(product?.extension_attributes?.brand_name && {
          item_brand: product?.extension_attributes?.brand_name,
        }),
        ...(Array.isArray(product?.option_text_brand) &&
          product?.option_text_brand?.length > 0 && {
            item_brand: product?.option_text_brand?.[0],
          }),
        ...(product?.extension_attributes?.category_names?.at(0) && {
          category_name: product?.extension_attributes?.category_names?.at(0),
          // product?.extension_attributes?.category_names?.at(0)?.name,
          // category_id: product?.extension_attributes?.category_names?.at(0)?.id,
        }),
        ...(product?.extension_attributes?.category_names?.at(1) && {
          item_category1: product?.extension_attributes?.category_names?.at(1),
          // product?.extension_attributes?.category_names?.at(1)?.name,
          // item_category1_id:
          //   product?.extension_attributes?.category_names?.at(1)?.id,
        }),
        ...(product?.extension_attributes?.category_names?.at(2) && {
          item_category2:
            // product?.extension_attributes?.category_names?.at(2)?.name,
            product?.extension_attributes?.category_names?.at(2),
          // item_category2_id:
          //   product?.extension_attributes?.category_names?.at(2)?.id,
        }),
        ...(product?.extension_attributes?.category_names?.at(3) && {
          item_category3:
            // product?.extension_attributes?.category_names?.at(3)?.name,
            product?.extension_attributes?.category_names?.at(3),
          // item_category3_id:
          //   product?.extension_attributes?.category_names?.at(3)?.id,
        }),
        ...(product?.extension_attributes?.category_names?.at(4) && {
          item_category4: product?.extension_attributes?.category_names?.at(4),
          // product?.extension_attributes?.category_names?.at(4)?.name,
          // item_category4_id:
          //   product?.extension_attributes?.category_names?.at(4)?.id,
        }),
        ...(product?.extension_attributes?.category_names?.at(5) && {
          item_category5:
            product?.extension_attributes?.category_names?.at(5)?.name,
          //   product?.extension_attributes?.category_names?.at(5)?.name,
          // item_category5_id:
          //   product?.extension_attributes?.category_names?.at(5)?.id,
        }),
        ...(product?._category_?.sub_categories?.[1] && {
          sub_category_id: String(
            product?._category_?.sub_categories?.[1]?.category_id
          ),
          sub_category_name: product?._category_?.sub_categories?.[1]?.name,
        }),
        ...(product?._category_?.main_category && {
          category_id: String(product?._category_?.main_category?.category_id),
          category_name: product?._category_?.main_category?.name,
        }),
        ...(product?._media_?.image?.[0]?.image && {
          image: product?._media_?.image?.[0]?.image,
        }),
        price:
          product?.extension_attributes?.special_price ||
          product?.extension_attributes?.original_price ||
          product?.prices_with_tax?.price ||
          product?.prices_with_tax?.original_price,
        quantity: product?.qty,
      },
    ],
  });
};

export const event_add_to_cart = (product, qty) =>
  pushToDataLayer("add_to_cart", {
    currency: "SAR",
    value:
      (product?.prices_with_tax?.price ||
        product?.prices_with_tax?.original_price) * qty,
    items: [
      {
        item_id: product?.sku,
        item_name: product?.name?.[0],
        discount: getDiscount(
          product?.prices_with_tax?.original_price,
          product?.prices_with_tax?.price
        ),
        index: 1,
        ...(product?.option_text_brand?.at(0) && {
          item_brand: product?.option_text_brand?.at(0),
        }),
        ...(product?._category_?.main_category?.name && {
          item_category: product?._category_?.main_category?.name,
          item_list_name: product?._category_?.main_category?.name,
        }),
        ...(product?._category_?.sub_categories?.at(0)?.name && {
          item_category2: product?._category_?.sub_categories?.at(0)?.name,
        }),
        ...(product?._category_?.sub_categories?.at(1)?.name && {
          item_category3: product?._category_?.sub_categories?.at(1)?.name,
          sub_category_id: String(
            product?._category_?.sub_categories?.at(1)?.category_id
          ),
        }),
        ...(product?._category_?.sub_categories?.at(2)?.name && {
          item_category4: product?._category_?.sub_categories?.at(2)?.name,
        }),
        ...(product?._category_?.sub_categories?.at(3)?.name && {
          item_category5: product?._category_?.sub_categories?.at(3)?.name,
        }),
        ...(product?._category_?.main_category?.category_id && {
          item_list_id: String(product?._category_?.main_category?.category_id),
        }),
        image: product?._media_?.image?.[0]?.image,
        price:
          product?.prices_with_tax?.price ||
          product?.prices_with_tax?.original_price,
        quantity: qty,
      },
    ],
  });

export const event_add_to_wishlist_from_cart = (product) =>
  pushToDataLayer("add_to_wishlist", {
    currency: "SAR",
    value:
      product?.qty *
      (product?.extension_attributes?.special_price ||
        product?.extension_attributes?.original_price),
    items: [
      {
        item_id: product?.extension_attributes?.product_sku,
        item_name: product?.name,
        // coupon: "SUMMER_FUN",
        discount: getDiscount(
          product?.extension_attributes?.original_price,
          product?.extension_attributes?.special_price
        ),
        index: 1,
        ...(product?.extension_attributes?.brand_name && {
          item_brand: product?.extension_attributes?.brand_name,
        }),
        ...(product.extension_attributes?.category_names?.at(0) && {
          category_name: product.extension_attributes?.category_names?.at(0),
          // product.extension_attributes?.category_names?.at(0)?.name,
          // category_id: product.extension_attributes?.category_names?.at(0)?.id,
        }),
        ...(product.extension_attributes?.category_names?.at(1) && {
          item_category1: product.extension_attributes?.category_names?.at(1),
          // product.extension_attributes?.category_names?.at(1)?.name,
          // item_category1_id:
          //   product.extension_attributes?.category_names?.at(1)?.id,
        }),
        ...(product.extension_attributes?.category_names?.at(2) && {
          item_category2:
            // product.extension_attributes?.category_names?.at(2)?.name,
            product.extension_attributes?.category_names?.at(2),
          // item_category2_id:
          //   product.extension_attributes?.category_names?.at(2)?.id,
        }),
        ...(product.extension_attributes?.category_names?.at(3) && {
          item_category3:
            // product.extension_attributes?.category_names?.at(3)?.name,
            product.extension_attributes?.category_names?.at(3),
          // item_category3_id:
          //   product.extension_attributes?.category_names?.at(3)?.id,
        }),
        ...(product.extension_attributes?.category_names?.at(4) && {
          item_category4: product.extension_attributes?.category_names?.at(4),
          // product.extension_attributes?.category_names?.at(4)?.name,
          // item_category4_id:
          //   product.extension_attributes?.category_names?.at(4)?.id,
        }),
        ...(product.extension_attributes?.category_names?.at(5) && {
          item_category5:
            product.extension_attributes?.category_names?.at(5)?.name,
          //   product.extension_attributes?.category_names?.at(5)?.name,
          // item_category5_id:
          //   product.extension_attributes?.category_names?.at(5)?.id,
        }),
        price:
          product?.extension_attributes?.special_price ||
          product?.extension_attributes?.original_price,
        quantity: product?.qty,
      },
    ],
  });

// related to +,- from cart page
export const event_toggle_from_cart_page = (product, qty, event_name) =>
  pushToDataLayer(event_name, {
    currency: "SAR",
    value:
      qty *
      (product?.extension_attributes?.special_price ||
        product?.extension_attributes?.original_price),
    items: [
      {
        item_id: product?.extension_attributes?.product_sku,
        item_name: product?.name,
        // coupon: "SUMMER_FUN",
        discount: getDiscount(
          product?.extension_attributes?.original_price,
          product?.extension_attributes?.special_price
        ),
        index: 1,
        ...(product?.extension_attributes?.brand_name && {
          item_brand: product?.extension_attributes?.brand_name,
        }),
        ...(product?.extension_attributes?.category_names?.at(0) && {
          item_category:
            product?.extension_attributes?.category_names?.at(0)?.name,
        }),
        ...(product?.extension_attributes?.category_names?.at(1) && {
          item_category2:
            product?.extension_attributes?.category_names?.at(1)?.name,
        }),
        ...(product?.extension_attributes?.category_names?.at(2) && {
          item_category3:
            product?.extension_attributes?.category_names?.at(2)?.name,
        }),
        ...(product?.extension_attributes?.category_names?.at(3) && {
          item_category4:
            product?.extension_attributes?.category_names?.at(3)?.name,
        }),
        ...(product?.extension_attributes?.category_names?.at(4) && {
          item_category5:
            product?.extension_attributes?.category_names?.at(4)?.name,
        }),
        price:
          product?.extension_attributes?.special_price ||
          product?.extension_attributes?.original_price,
        quantity: qty,
      },
    ],
  });

// PDP (event_name is used for select item event when i click on any product card)
export const event_view_item = (product, event_name) =>
  pushToDataLayer(event_name || "view_item", {
    currency: "SAR",
    value:
      product?.prices_with_tax?.price ||
      product?.prices_with_tax?.original_price,
    items: [
      {
        item_id: product?.sku,
        item_name: product?.name?.[0],
        discount: getDiscount(
          product?.prices_with_tax?.original_price,
          product?.prices_with_tax?.price
        ),
        index: 1,
        ...(product?.option_text_brand?.at(0) && {
          item_brand: product?.option_text_brand?.at(0),
        }),
        ...(product?._category_?.main_category?.name && {
          item_category: product?._category_?.main_category?.name,
          item_list_name: product?._category_?.main_category?.name,
        }),
        ...(product?._category_?.sub_categories?.at(1)?.name && {
          sub_category_name: product?._category_?.sub_categories?.at(1)?.name,
        }),
        ...(product?._category_?.sub_categories?.at(2)?.name && {
          item_category4: product?._category_?.sub_categories?.at(2)?.name,
        }),
        ...(product?._category_?.sub_categories?.at(3)?.name && {
          item_category5: product?._category_?.sub_categories?.at(3)?.name,
        }),
        ...(product?._category_?.main_category?.category_id && {
          item_list_id: String(product?._category_?.main_category?.category_id),
        }),
        ...(product?._category_?.sub_categories?.[1]?.category_id && {
          sub_category_id: String(
            product?._category_?.sub_categories?.[1]?.category_id
          ),
        }),
        image: product?._media_?.image?.[0]?.image,
        price:
          product?.prices_with_tax?.price ||
          product?.prices_with_tax?.original_price,
        quantity: 1,
      },
    ],
  });

// Wish list updated
export const wishlist_updated = (
  products = [],
  event_name = "wishlist_updated"
) => {
  return pushToDataLayer(event_name, {
    currency: "SAR",
    sub_total: getTotalPrices(products),
    total: priceBeforeTax(getTotalPrices(products)),
    discount: getTotalDiscount(products),
    items: products.map((product) => {
      return {
        category_id: String(product?._category_?.main_category?.category_id),
        category_name: product?._category_?.main_category?.name,
        sub_category_id: String(
          product?._category_?.sub_categories?.[1]?.category_id
        ),
        sub_category_name: product?._category_?.sub_categories?.[1]?.name,
        sku_id: product?.sku,
        sku_name: Array.isArray(product?.name)
          ? product?.name?.[0]
          : product?.name,
        image: product?._media_?.image?.[0]?.image,
      };
    }),
    item_ids: products.map((product) => product?.sku).join(","),
    item_names: products.map((product) => product?.name?.[0]).join(","),
    number_of_products: products?.length,
  });
};

// Handle Banner Clicked Event
export const banner_clicked_event = (banner, locale) => {
  return pushToDataLayer("banner_clicked", {
    banner_name: banner?.[`title-${locale}`],
    // banner_category: "",
  });
};

// Category Page
export const event_view_item_list = (currentCategory) =>
  pushToDataLayer("view_item_list", {
    item_list_id: String(currentCategory?.id),
    item_list_name: currentCategory?.name,
    product_count: currentCategory?.product_count,
  });

// Event Sub Category
export const event_sub_item_list = (currentCategory, parentCategory) =>
  pushToDataLayer("sub_category_view", {
    category_id: String(parentCategory?.id),
    category_name: parentCategory?.name,
    product_count: currentCategory?.product_count,
    sub_category_id: String(currentCategory?.id),
    sub_category_name: currentCategory?.name,
  });

export const event_search_result_item_list = (
  inputSearchValue,
  total_items
) => {
  pushToDataLayer("search_term", {
    key_word: inputSearchValue,
    total_items,
  });
};

export const event_user_login = (user) => {
  const { firstname, lastname, email, custom_attributes, created_at } =
    user || {};
  const mobile = custom_attributes
    ?.filter((item) => item.attribute_code.includes("mobile") && item.value)
    ?.at(0)?.value;
  const is_company =
    custom_attributes?.find((item) =>
      item?.attribute_code.includes("is_company")
    )?.value == "1";
  const userData = {
    firstname,
    lastname,
    ...(email ? { email } : {}),
    ...(mobile
      ? {
          mobile: "+966".concat(mobile.slice(-9)),
          user_id: "966" + mobile.slice(-9),
        }
      : {}),
    is_company,
    ...(created_at && { created_date: created_at }),
  };
  pushToDataLayer("user_login", userData);
};

// Failure Payment Event
export const event_failed_payment = (data) => {
  pushToDataLayer("payment_failed", {
    payment_mode: data?.checkout_payment_code,
    sub_total: data?.checkout_sub_total,
    tax: data?.checkout_tax_amount,
    total: data?.checkout_total,
    total_discount: data?.checkout_total_discount,
    ...(data?.checkout_coupon_discount_amount && {
      coupon_discount_amount: data?.checkout_coupon_discount_amount,
    }),
  });
};

// News Letter Subscribed
export const news_letter_subscribed = (email) => {
  pushToDataLayer("news_letter_subscribed", {
    email,
  });
};

export const language_change = (language) => {
  pushToDataLayer("language_change", {
    language,
  });
};

export const register_event = (email, name, phone_number, is_company) => {
  pushToDataLayer("user_sign_up", {
    email,
    name,
    phone_number: `966`.concat(phone_number.slice(-9)),
    user_id: `966`.concat(phone_number.slice(-9)),
    is_company,
  });
};

// Coupon Code Applied
export const coupon_applied_event = (cartData) => {
  pushToDataLayer("coupon_code_applied", {
    total_after_discount: cartData?.base_grand_total,
    total_before_discount:
      cartData?.base_grand_total - +cartData?.base_discount_amount,
    coupon_code: cartData?.coupon_code,
    coupon_discount_amount: cartData?.base_discount_amount,
  });
};

export const coupon_failed_event = (coupon_code) => {
  pushToDataLayer("coupon_code_failed", {
    coupon_code,
  });
};

export const logout_event = (email, phone, first_name, last_name) => {
  return pushToDataLayer("user_logout", {
    email,
    ...(phone && {
      phone: `+966`.concat(phone.slice(-9)),
      user_id: "966" + phone.slice(-9),
    }),
    first_name,
    last_name,
  });
};

export const company_event = (company) => {
  return pushToDataLayer("company_address_added", {
    customer_name: company?.customer_name,
    email: company?.email,
    mobile_number: company?.mobile_number,
    vat_certificate: company?.vat_certificate,
    commercial_registration: company?.commercial_registration,
    saudi_national_address: company?.saudi_national_address,
    owner_saudi_id: company?.owner_saudi_id,
    known_as: company?.known_as,
  });
};

export const event_add_shipping_info = (
  cartData,
  info,
  shipping_method,
  companyInfo
) => {
  return pushToDataLayer("add_shipping_info", {
    currency: "SAR",
    value: cartData?.grand_total,
    total: priceBeforeTax(cartData?.grand_total),
    ...((info?.city || info?.region) && {
      region: info?.city || info?.region,
    }),
    first_name: info?.firstname,
    last_name: info?.lastname,
    mobile_number: info?.telephone?.slice(-9),
    items: cartData?.items?.map((item, i) => {
      return {
        item_id: item?.extension_attributes?.product_sku,
        item_name: item?.name,
        discount: getDiscount(
          item?.extension_attributes?.original_price,
          item?.extension_attributes?.special_price
        ),
        index: i + 1,
        ...(item?.extension_attributes?.brand_name && {
          item_brand: item?.extension_attributes?.brand_name,
        }),
        ...(item?.extension_attributes?.category_names?.at(0) && {
          category_name: item?.extension_attributes?.category_names?.at(0),
          // item?.extension_attributes?.category_names?.at(0)?.name,
          // category_id: item?.extension_attributes?.category_names?.at(0)?.id,
        }),
        ...(item?.extension_attributes?.category_names?.at(1) && {
          item_category1: item?.extension_attributes?.category_names?.at(1),
          // item?.extension_attributes?.category_names?.at(1)?.name,
          // item_category1_id:
          //   item?.extension_attributes?.category_names?.at(1)?.id,
        }),
        ...(item?.extension_attributes?.category_names?.at(2) && {
          item_category2:
            // item?.extension_attributes?.category_names?.at(2)?.name,
            item?.extension_attributes?.category_names?.at(2),
          // item_category2_id:
          //   item?.extension_attributes?.category_names?.at(2)?.id,
        }),
        ...(item?.extension_attributes?.category_names?.at(3) && {
          item_category3:
            // item?.extension_attributes?.category_names?.at(3)?.name,
            item?.extension_attributes?.category_names?.at(3),
          // item_category3_id:
          //   item?.extension_attributes?.category_names?.at(3)?.id,
        }),
        ...(item?.extension_attributes?.category_names?.at(4) && {
          item_category4: item?.extension_attributes?.category_names?.at(4),
          // item?.extension_attributes?.category_names?.at(4)?.name,
          // item_category4_id:
          //   item?.extension_attributes?.category_names?.at(4)?.id,
        }),
        ...(item?.extension_attributes?.category_names?.at(5) && {
          item_category5: item?.extension_attributes?.category_names?.at(5),
          //   item?.extension_attributes?.category_names?.at(5),
          // item_category5_id:
          //   item?.extension_attributes?.category_names?.at(5)?.id,
        }),
        product_image: `${process.env.NEXT_PUBLIC_IMG_BASEURL}/catalog/product/${item?.extension_attributes?.product_image}`,
        price:
          item?.extension_attributes?.special_price ||
          item?.extension_attributes?.original_price,
        quantity: item?.qty,
      };
    }),
    shipping_method,
    number_of_products: cartData?.items?.length,
    pay_later: false,
    cash_on_delivery: false,
    sku_ids: cartData?.items
      ?.map((item) => item?.extension_attributes?.product_sku)
      ?.join(","),
    item_names: cartData?.items?.map((item) => item?.name)?.join(","),
    number_of_products: cartData?.items?.length || 0,
    // subtotal: cartData?.subtotal,
    ...(cartData?.tax_amount && { tax_amount: cartData?.tax_amount }),
    discount: getTotalDiscount(cartData?.items),
    ...(companyInfo &&
      Object.keys(companyInfo || {}).length > 0 && {
        customer_name: companyInfo?.customer_name,
        email: companyInfo?.email,
        mobile_number: companyInfo?.mobile_number,
        vat_certificate: companyInfo?.vat_certificate,
        commercial_registration: companyInfo?.commercial_registration,
        saudi_national_address: companyInfo?.saudi_national_address,
        owner_saudi_id: companyInfo?.owner_saudi_id,
        known_as: companyInfo?.known_as,
      }),
  });
};
